import { isOpenInApp, stringToBoolean } from "@repo/shared-utils/pwa-utils";
import { DEMAT_MODAL_KEY } from "./DematConstant";

export const isValidIndianMobileNumber = (mobileNumber: string): boolean => {
  return /^[6-9]\d{9}$/.test(mobileNumber);
};

export const hasAllRepeatingDigits = (mobileNumber: string): boolean => {
  return /^(\d)\1{9}$/.test(mobileNumber);
};
export const validateMobileNumber = (
  mobileNumber: string,
): { isValid: boolean; errorMessage: string } => {
  if (!mobileNumber) {
    return { isValid: false, errorMessage: DEMAT_MODAL_KEY.enterMobileNumber };
  } else if (mobileNumber.length !== 10) {
    return {
      isValid: false,
      errorMessage: DEMAT_MODAL_KEY.invalidMobileNumber,
    };
  } else if (
    !isValidIndianMobileNumber(mobileNumber) ||
    hasAllRepeatingDigits(mobileNumber)
  ) {
    return {
      isValid: false,
      errorMessage: DEMAT_MODAL_KEY.invalidMobileNumberFormat,
    };
  }

  return { isValid: true, errorMessage: "" };
};

export const redirectWithUtmParams = (url: string, redirectType: string) => {
  try {
    const redirectUrl = new URL(url);
    redirectUrl.searchParams.append("utm_source", "widget");
    redirectUrl.searchParams.append("utm_medium", "organic_bfl");
    redirectUrl.searchParams.append(
      "utm_campaign",
      window.location?.href.split("/").pop() ?? "",
    );

    if (isOpenInApp()) {
      window.prompt(
        `openInAppWebViewActivity://{"url":"${redirectUrl.toString()}","title":"Bajaj Broking"}`,
      );
    } else {
      window.open(
        redirectUrl.toString(),
        stringToBoolean(redirectType) ? "_blank" : "_self",
      );
    }
  } catch (err) {
    // Log the error for debugging
    console.error("Error constructing redirect URL:", err);

    // Fallback: redirect to original URL if URL construction fails
    if (isOpenInApp()) {
      window.prompt(
        `openInAppWebViewActivity://{"url":"${url}","title":"Bajaj Broking"}`,
      );
    } else {
      window.open(url, stringToBoolean(redirectType) ? "_blank" : "_self");
    }
  }
};

export interface ISSORedirectParams {
  buySellRedirectUrl: string;
  tokenExchId: {
    exchId: string;
    formattedSymbol: string;
  };
  sectionTitle?: string;
  headerName: string;
}
